var _metadata, _clipPath, _clipPath2, _sodipodiNamedview, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerFilledRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "svg6076",
    inkscapeVersion: "0.91 r13725",
    xmlSpace: "preserve",
    width: 42.5,
    height: 62.537498,
    viewBox: "0 0 42.5 62.537498",
    sodipodiDocname: "marker-red.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata6082"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("defs", {
    id: "defs6080"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6090"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.5,5.999 C 6.5,2.686 11.201,0 17,0 l 0,0 c 5.799,0 10.5,2.686 10.5,5.999 l 0,0 C 27.5,9.314 22.799,12 17,12 l 0,0 C 11.201,12 6.5,9.314 6.5,5.999",
    id: "path6092",
    "inkscapeConnector-curvature": 0
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.5,0,0,5.9850001,17,5.9486976)",
    spreadMethod: "pad",
    id: "radialGradient6102"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 0.50000763,
      stopColor: "#ffffff"
    },
    offset: 0,
    id: "stop6104"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 0.50000763,
      stopColor: "#ffffff"
    },
    offset: 0.07,
    id: "stop6106"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    },
    offset: 1,
    id: "stop6108"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "mask6110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -32768,32767 65535,0 0,-65535 -65535,0 0,65535 z",
    style: {
      fill: "url(#radialGradient6102)",
      stroke: "none"
    },
    id: "path6120",
    "inkscapeConnector-curvature": 0
  })))))), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.5,0,0,5.9850001,17,5.9486976)",
    spreadMethod: "pad",
    id: "radialGradient6126"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#000000"
    },
    offset: 0,
    id: "stop6128"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#000000"
    },
    offset: 0.07,
    id: "stop6130"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#808080"
    },
    offset: 1,
    id: "stop6132"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,50.03 34,0 L 34,0 0,0 0,50.03 Z",
    id: "path6142",
    "inkscapeConnector-curvature": 0
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 501,
    "inkscapeWindow-height": 403,
    id: "namedview6078",
    showgrid: "false",
    inkscapeZoom: 3.7737359,
    inkscapeCx: 21.25,
    inkscapeCy: 31.268749,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 0,
    "inkscapeCurrent-layer": "g6084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6084",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "map_markers",
    transform: "matrix(1.25,0,0,-1.25,0,62.5375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6088",
    clipPath: "url(#clipPath6090)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6094"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6096"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6122",
    mask: "url(#mask6110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.5,5.999 C 6.5,2.686 11.201,0 17,0 l 0,0 c 5.799,0 10.5,2.686 10.5,5.999 l 0,0 C 27.5,9.314 22.799,12 17,12 l 0,0 C 11.201,12 6.5,9.314 6.5,5.999",
    style: {
      fill: "url(#radialGradient6126)",
      stroke: "none"
    },
    id: "path6134",
    "inkscapeConnector-curvature": 0
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g6136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6138",
    clipPath: "url(#clipPath6140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6144",
    transform: "translate(2,33.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-8.28 15,-24 15,-24 15,-24 30,-8.28 30,0 30,8.284 23.284,15 15,15 6.716,15 0,8.284 0,0",
    style: {
      fill: "#ff1f2f",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    id: "path6146",
    "inkscapeConnector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6148",
    transform: "translate(17,50.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -9.389,0 -17,-7.611 -17,-17 0,-8.83 14,-23.71 15.55,-25.38 L 0,-43.9 1.45,-42.38 C 3,-40.71 17,-25.83 17,-17 17,-7.611 9.389,0 0,0 m 0,-2 c 8.284,0 15,-6.716 15,-15 0,-8.28 -15,-24 -15,-24 0,0 -15,15.72 -15,24 0,8.284 6.716,15 15,15",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    id: "path6150",
    "inkscapeConnector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6152",
    transform: "translate(17,38.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.762,0 5,-2.239 5,-5 0,-2.761 -2.238,-5 -5,-5 -2.762,0 -5,2.239 -5,5 0,2.761 2.238,5 5,5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    id: "path6154",
    "inkscapeConnector-curvature": 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFilledRed);
export default __webpack_public_path__ + "static/media/marker-filled-red.1879db154c16ff8024ac0698790f3665.svg";
export { ForwardRef as ReactComponent };